import { useParams } from 'react-router-dom';
import { useEntityUrl, UrlParams } from 'framework/routing';

const ONE_STOP_HISTORY_ROOT_PATH = '/my-activity';
export const ONE_STOP_HISTORY_PATH = `${ONE_STOP_HISTORY_ROOT_PATH}/requests`;
export const ONE_STOP_HISTORY_REQUEST_ID = 'requestId';

export const useOneStopHistoryRequestId = () => {
  const urlParams: UrlParams = useParams<Dictionary<string>>();

  return urlParams[ONE_STOP_HISTORY_REQUEST_ID];
};

export const useOneStopHistoryUrl = () => {
  const historyUrl = useEntityUrl({
    baseLink: ONE_STOP_HISTORY_PATH,
  });

  return {
    ...historyUrl,
  };
};
